import { gql } from "@apollo/client";
export const SALES_RESPONSIBLES_QUERY = gql`
  query automaticUserAllocationsResponsiblesByUserGroups {
    automaticUserAllocationsResponsiblesByUserGroups {
      salesResponsibles {
        personId
        lastName
        firstName
      }
    }
  }
`;
